document.addEventListener('DOMContentLoaded', function() {

  let chck_if_weglot_loaded = setInterval( function() {
    if( Weglot ) {

      setTimeout(()=> {

        if (typeof isBackgroundImageLoaded === 'function') {
          const element = document.querySelector('.ecom-core.ecom-j8ld6cp37rp > .core__column--wrapper');
          isBackgroundImageLoaded(element);
        }
      }, 50);
      
      clearInterval( chck_if_weglot_loaded );
    }
  }, 100);
  
  const bottomColumns = document.querySelectorAll('.ecom-vam8d2ee20j>.core__row--columns>.ecom-column');

  if( bottomColumns.length ) {
    bottomColumns.forEach(column => {

      column.addEventListener('click', function(e) {

        e.preventDefault();
        e.stopPropagation();
        
        let item = e.target;
        
        const parentElement = item.closest(".booking-link");
        if( parentElement ) {
          const link = parentElement.querySelector('a');
          if( link ) {
           window.open(link.href, '_blank');
          }
        }
      });

      column.addEventListener('mouseenter', function(e) {

        let item = e.target;
        const a = item.querySelector('a');
        if( a ) {
          a.classList.add('active');
        }
      });

      column.addEventListener('mouseleave', function(e) {

        let item = e.target;
        const a = item.querySelector('a');
        if( a ) {
          a.classList.remove('active');
        }
      });
      
    });
  }

  function isBackgroundImageLoaded(element) {
    const style = window.getComputedStyle(element);
    const backgroundImage = style.backgroundImage;
  
    if (backgroundImage === 'none' || !backgroundImage) {
        console.log('No background image set.');
        return false;
    }
  
    const url = backgroundImage.slice(5, -2);
    const img = new Image();
    img.src = url;
  
    img.onload = () => {
      const delayedAnimElements = document.querySelectorAll('.delayed-anim');
      delayedAnimElements.forEach(el => {
        el.classList.remove('delayed-anim');
      });
    };
  
    img.onerror = () => {
        console.log('Failed to load background image.');
    };
  }
});